import React, { FC } from 'react';
import { SocialProvider, SocialProviderName } from './../types/socialAccounts.types';
import SocialProviderItem from '../../../app/common/components/SocialProviderItem';
import { SocialAccountRatEvents } from '../utils/socialAccountRatEvents';

interface SocialAccountItemProps {
    provider: SocialProvider;
    unlinkTargetId: string;
    onUnlink: (provider: SocialProvider) => void;
    disabled?: boolean;
}

const PROVIDER_ICONS: Record<SocialProviderName, string> = {
    Google: '/assets/logo/logo_google.svg',
    Facebook: '/assets/logo/logo_facebook.svg',
    Apple: '/assets/logo/logo_apple.svg',
};

/**
 * AP Region wrapper for SocialProviderItem
 * Handles data transformation from AP's SocialProvider type to the shared component props
 */
const SocialAccountItem: FC<SocialAccountItemProps> = ({
    provider,
    unlinkTargetId,
    onUnlink,
    disabled = false,
}) => {
    const handleUnlinkClick = () => {
        SocialAccountRatEvents.trackUnlinkClick(provider.providerName, unlinkTargetId);
        onUnlink(provider);
    };

    return (
        <SocialProviderItem
            providerName={provider.providerName}
            providerKey={provider.providerName.toLowerCase()}
            iconSrc={PROVIDER_ICONS[provider.providerName]}
            onUnlink={handleUnlinkClick}
            disabled={disabled}
        />
    );
};

export default SocialAccountItem;
